import { SITE } from "@/lib/site";

export default function WhatsAppFab() {
  const href = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(
    "Hi Lemonsqueezy team, I'd like to talk about my brand."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-50 inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white animate-wa-pulse hover:scale-105 transition-transform shadow-lg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="h-7 w-7"
        fill="currentColor"
        aria-hidden="true"
      >
        <path d="M19.11 17.59c-.27-.13-1.59-.78-1.84-.87-.25-.09-.43-.13-.6.13-.18.27-.7.87-.86 1.05-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.16-1.34-.8-.71-1.34-1.6-1.5-1.87-.16-.27-.02-.41.12-.54.12-.12.27-.32.4-.48.13-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.6-1.45-.82-1.99-.22-.52-.44-.45-.6-.46l-.51-.01c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29s.99 2.66 1.13 2.85c.13.18 1.95 2.98 4.73 4.18.66.28 1.18.46 1.58.59.66.21 1.27.18 1.74.11.53-.08 1.59-.65 1.81-1.27.22-.62.22-1.15.16-1.27-.06-.12-.24-.18-.51-.31zM16.02 4C9.39 4 4 9.39 4 16.02c0 2.4.7 4.74 2.02 6.78L4 28l5.36-2c1.96 1.07 4.18 1.64 6.66 1.64h.01c6.62 0 12-5.39 12-12.02C28.04 9.39 22.65 4 16.02 4zm0 21.93h-.01c-2.21 0-4.36-.6-6.24-1.74l-.45-.27-3.18 1.19 1.21-3.1-.29-.46a9.93 9.93 0 0 1-1.55-5.32C5.51 10.25 10.21 5.5 16.02 5.5c5.79 0 10.5 4.74 10.5 10.52 0 5.78-4.71 10.5-10.5 10.91z" />
      </svg>
    </a>
  );
}
